export enum StorageType {
  MASS = 'mass',
  RACK = 'rackTrd',
  ACCU = 'rackAcc',
}
